// Autogenerated by publish_packages.clj
const version = 'v0.17.32';
export default version;
//# sourceMappingURL=version.js.map